export class CustomerDetails {
  constructor(
    public customers: string[],
    public customerGroups: string[]
  ) {}
}
